import { useEffect, useState } from "react";

// How long a gap lasts before the line calls it thinking, so quick tool calls
// in a row don't flash it.
export const SETTLE_MS = 300;

// When the thinking began on this device's clock: the server's count, taken
// back from when it arrived. The device's clock only measures time since.
export const thinkingStart = (seconds: number, receivedAt: number) =>
  receivedAt - seconds * 1000;

// Whole seconds since `start`, once it has lasted SETTLE_MS.
export const thinkingSeconds = (start: number, now: number) => {
  const elapsed = now - start;
  if (elapsed < SETTLE_MS) return null;
  return Math.floor(elapsed / 1000);
};

// Seconds the answer in progress has been thinking, counted on from the
// server's count (since its last tool call returned, or it began), so a
// reload, another screen or a device whose clock is off shows the same count.
export const useThinkingSeconds = ({
  running,
  seconds,
}: {
  running: boolean;
  seconds: number | null | undefined;
}) => {
  const [now, setNow] = useState(Date.now);
  const [start, setStart] = useState<number | null>(null);
  const counting = running && seconds != null;

  useEffect(() => {
    setStart(counting ? thinkingStart(seconds, Date.now()) : null);
  }, [counting, seconds]);

  useEffect(() => {
    if (start === null) return;
    const tock = () => setNow(Date.now());
    const settle = setTimeout(
      tock,
      Math.max(0, start + SETTLE_MS - Date.now()),
    );
    const tick = setInterval(tock, 1000);
    return () => {
      clearTimeout(settle);
      clearInterval(tick);
    };
  }, [start]);

  return start === null ? null : thinkingSeconds(start, now);
};
